import { List } from 'immutable';

import { currentOrLegacyReportEffects } from './currentOrLegacyReport';
import { currentOrLegacySavedViewEffects } from './currentOrLegacySavedView';

export const effects = List([currentOrLegacyReportEffects, currentOrLegacySavedViewEffects]);

export { currentOrLegacyReportEffects, currentOrLegacySavedViewEffects };
